import { render, staticRenderFns } from "./WorkerQandA.vue?vue&type=template&id=63f75614&scoped=true"
import script from "./WorkerQandA.vue?vue&type=script&lang=js"
export * from "./WorkerQandA.vue?vue&type=script&lang=js"
import style0 from "./WorkerQandA.vue?vue&type=style&index=0&id=63f75614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f75614",
  null
  
)

export default component.exports